import { Popover } from 'radix-ui';
import { MoreHorizontal } from 'lucide-react';
import { createContext, useLayoutEffect, useRef, useState, type ReactNode } from 'react';
import { useChatCopy } from '@/lib/chat-i18n';
import { useNarrowViewport } from '@/lib/mobile';

/** True inside the narrow-width actions popover: its items are already one menu, so they are not nested again. */
export const InChatActionsMenu = createContext(false);

/** Keep actions reachable when the chat column narrows, including beside a canvas. */
export function ResponsiveChatActions({ children }: { children: ReactNode }) {
  const anchor = useRef<HTMLDivElement>(null);
  const narrowViewport = useNarrowViewport();
  const [narrowColumn, setNarrowColumn] = useState(false);
  useLayoutEffect(() => {
    const header = anchor.current?.parentElement;
    if (!header || typeof ResizeObserver === 'undefined') return;
    const update = () => setNarrowColumn(header.getBoundingClientRect().width <= 800);
    update();
    const observer = new ResizeObserver(update);
    observer.observe(header);
    return () => observer.disconnect();
  }, []);
  const copy = useChatCopy();
  return (
    <div ref={anchor} className="responsive-chat-actions">
      {!narrowViewport && !narrowColumn ? (
        children
      ) : (
        <Popover.Root>
          <Popover.Trigger asChild>
            <button
              type="button"
              className="ws-icon-button mobile-chat-actions-trigger"
              aria-label={copy.chatActions}
            >
              <MoreHorizontal size={20} aria-hidden="true" />
            </button>
          </Popover.Trigger>
          <Popover.Content
            align="end"
            sideOffset={8}
            className="mobile-chat-actions"
            aria-label={copy.chatActions}
          >
            <InChatActionsMenu.Provider value>{children}</InChatActionsMenu.Provider>
          </Popover.Content>
        </Popover.Root>
      )}
    </div>
  );
}
